<template>
    <div>
        <div class="constructor">
            <transition name="fade">
                <div class="alert alert--success constructor__alert" v-if="isSuccess">Ваша цепь сформирована и отправлена в корзину</div>
            </transition>
            <div class="constructor-progress">
                <div class="constructor-progress__step" v-for="(step, index) in progressLabels" :class="{'d-none': index === 4 || index > 4 && (steps[4] == undefined || steps[4] == 1), 'constructor-progress__step--filled': isFilledTab(index) }" @click="isFilledTab(index) ? selectTab(index) : false">
                    <div class="constructor-progress__label" v-text="step"></div>
                    <div class="constructor-progress__value">
                        <transition name="slide-up-abs">
                            <span v-text="variants[index][steps[index]]?.text || variants[index][steps[index]]" v-if="(variants[index][steps[index]]?.text || variants[index][steps[index]]) !== undefined" :key="variants[index][steps[index]]?.text || variants[index][steps[index]]"></span>
                        </transition>
                    </div>
                </div>

            </div>
            <div class="constructor-tabs">
                <transition name="tab">
                    <div class="conctructor-tabs__tab" v-show="tab === 0">
                        Разрушающая нагрузка цепей, в том числе тяговой пластинчатой, напрямую зависит от толщины пластины (s, мм).<br>
                        Определите необходимую разрушающую нагрузку:<br><br>
                        <div class="constructor-variants constructor-variants--max-width">
                            <button type="button" class="constructor-variant__btn" v-for="(variant, index) in variants[0]" @click="selectVariant(0, index)" :key="index">
                                <div class="constructor-variant__text" :class="{'constructor-variant__text--selected': index === steps[0]}" v-text="variant.text"></div>
                                <div class="constructor-variant__description" v-text="variant.description"></div>
                            </button>
                        </div>
                    </div>
                </transition>
                <transition name="tab">
                    <div class="conctructor-tabs__tab" v-show="tab === 1">
                        Выберите тип цепи<br>
                        <div class="constructor-variants">
                            <button type="button" class="constructor-variant__btn constructor-variant__btn--half-width" v-for="(variant, index) in variants[1]" @click="selectVariant(1, index)" :key="index">
                                <picture class="constructor-variant__picture">
                                    <source type="image/webp" :srcset="`/img/constructor/II/${variant.image}.webp`">
                                    <source type="image/png" :srcset="`/img/constructor/II/${variant.image}.png`">
                                    <img :src="`/img/constructor/II/${variant.image}.png`">
                                </picture>
                                <div class="constructor-variant__text" :class="{'constructor-variant__text--selected': index === steps[1]}" v-text="variant.description"></div>
                            </button>
                        </div>
                    </div>
                </transition>
                <transition name="tab">
                    <div class="conctructor-tabs__tab" v-show="tab === 2">
                        Выберите шаг цепи<br>
                        <picture>
                            <source type="image/webp" srcset="/img/constructor/step.webp">
                            <source type="image/png" srcset="/img/constructor/step.png">
                            <img src="/img/constructor/step.png">
                        </picture><br>
                        <div class="constructor-variants">
                            <button type="button" class="constructor-variant__btn constructor-variant__text" :class="{'constructor-variant__text--selected': index === steps[2]}" v-for="(variant, index) in variants[2]" @click="selectVariant(2, index)" v-text="variant" :key="index"></button>
                        </div>
                    </div>
                </transition>
                <transition name="tab">
                    <div class="conctructor-tabs__tab" v-show="tab === 3">
                        Выберите исполнение цепи:<br><br>
                        <div class="constructor-variants">
                            <div class="constructor-variant__item" 
                                :class="{'constructor-variant__item--half-width': index > 0}" v-for="(variant, index) in variants[3]" :key="index">
                                <button type="button" class="constructor-variant__btn"
                                @click="selectVariant(3, index)">
                                    <picture class="constructor-variant__picture">
                                        <source type="image/webp" :srcset="`/img/constructor/III/${variant.image}.webp`">
                                        <source type="image/png" :srcset="`/img/constructor/III/${variant.image}.png`">
                                        <img :src="`/img/constructor/III/${variant.image}.png`">
                                    </picture>
                                    <div class="constructor-variant__text" :class="{'constructor-variant__text--selected': index === steps[3]}" v-text="variant.description"></div>
                                </button>
                                <picture class="constructor-variant__picture" v-if="index === 0">
                                    <source type="image/webp" srcset="/img/constructor/III/2.webp">
                                    <source type="image/png" srcset="/img/constructor/III/2.png">
                                    <img src="/img/constructor/III/2.png">
                                </picture>
                            </div>
                        </div>
                    </div>
                </transition>
                <transition name="tab">
                    <div class="conctructor-tabs__tab" v-show="tab === 4">
                        Ваша цепь имеет присоединительные элементы или отверстия на пластине?<br><br>
                        <div class="constructor-variants">
                            <button type="button" class="constructor-variant__btn constructor-variant__text" :class="{'constructor-variant__text--selected': index === steps[4]}" v-for="(variant, index) in variants[4]" @click="selectVariant(4, index)" v-text="variant.text" :key="index"></button>
                        </div>
                    </div>
                </transition>
                <transition name="tab">
                    <div class="conctructor-tabs__tab" v-show="tab === 5">
                        Выберите тип цепи<br>
                        <div class="constructor-variants">
                            <button type="button" class="constructor-variant__btn constructor-variant__btn--half-width" v-for="(variant, index) in variants[5]" @click="selectVariant(5, index)" :key="index">
                                <picture class="constructor-variant__picture">
                                    <source type="image/webp" :srcset="`/img/constructor/IV/${variant.image}.webp`">
                                    <source type="image/png" :srcset="`/img/constructor/IV/${variant.image}.png`">
                                    <img :src="`/img/constructor/IV/${variant.image}.png`">
                                </picture>
                                <div class="constructor-variant__text" :class="{'constructor-variant__text--selected': index === steps[5]}" v-text="variant.description"></div>
                            </button>
                        </div>
                    </div>
                </transition>
                <transition name="tab">
                    <div class="conctructor-tabs__tab" v-show="tab === 6">
                        Выберите тип цепи<br>
                        <picture class="constructor-variant__picture constructor-variant__picture--max-width-40">
                            <source type="image/webp" srcset="/img/constructor/V/1.webp">
                            <source type="image/png" srcset="/img/constructor/V/1.png">
                            <img src="/img/constructor/V/1.png">
                        </picture>
                        <div class="constructor-variants">
                            <button type="button" class="constructor-variant__btn constructor-variant__btn--half-width" v-for="(variant, index) in variants[6]" @click="selectVariant(6, index)" :key="index">
                                <div class="constructor-variant__text" :class="{'constructor-variant__text--selected': index === steps[6]}" v-text="variant.description"></div>
                            </button>
                        </div>
                    </div>
                </transition>
                <transition name="tab">
                    <div class="conctructor-tabs__tab" v-show="tab === 7">
                        Выберите расположение спецпластин в цепи:<br>
                        <div class="constructor-variants">
                            <button type="button" class="constructor-variant__btn constructor-variant__btn--half-width" v-for="(variant, index) in variants[7]" @click="selectVariant(7, index)" :key="index">
                                <picture class="constructor-variant__picture">
                                    <source type="image/webp" :srcset="`/img/constructor/VI/${variant.image}.webp`">
                                    <source type="image/png" :srcset="`/img/constructor/VI/${variant.image}.png`">
                                    <img :src="`/img/constructor/VI/${variant.image}.png`">
                                </picture>
                                <div class="constructor-variant__text" :class="{'constructor-variant__text--selected': index === steps[7]}" v-text="variant.description"></div>
                            </button>
                        </div>
                    </div>
                </transition>
                <transition name="tab">
                    <div class="conctructor-tabs__tab" v-show="tab === 8">
                        Выберите расположение спецпластин в цепи:<br>
                        <div class="constructor-variants">
                            <button type="button" class="constructor-variant__btn" @click="selectVariant(8, 0)">
                                <picture class="constructor-variant__picture constructor-variant__picture--max-width-70">
                                    <source type="image/webp" srcset="/img/constructor/VII/1.webp">
                                    <source type="image/png" srcset="/img/constructor/VII/1.png">
                                    <img src="/img/constructor/VII/1.png">
                                </picture>
                                <div class="constructor-variant__text":class="{'constructor-variant__text--selected': steps[8] === 0}">1 - на каждом звене</div>
                            </button>
                            <div class="constructor-variant__item">
                                <picture class="constructor-variant__picture constructor-variant__picture--max-width-70">
                                    <source type="image/webp" srcset="/img/constructor/VII/2.webp">
                                    <source type="image/png" srcset="/img/constructor/VII/2.png">
                                    <img src="/img/constructor/VII/2.png">
                                </picture>
                                
                                <button type="button" class="constructor-variant__btn constructor-variant__text" :class="{'constructor-variant__text--selected': steps[8] === 1}" @click="selectVariant(8, 1)">2</button>
                                <button type="button" class="constructor-variant__btn constructor-variant__text" :class="{'constructor-variant__text--selected': steps[8] === 2}" @click="selectVariant(8, 2)">4</button>
                                <button type="button" class="constructor-variant__btn constructor-variant__text" :class="{'constructor-variant__text--selected': steps[8] === 3}" @click="selectVariant(8, 3)">6</button>
                                <button type="button" class="constructor-variant__btn constructor-variant__text" :class="{'constructor-variant__text--selected': steps[8] === 4}" @click="selectVariant(8, 4)">8</button>
                                <button type="button" class="constructor-variant__btn constructor-variant__text" :class="{'constructor-variant__text--selected': steps[8] === 5}" @click="selectVariant(8, 5)">10</button> - четное чередование
                            </div>
                            <div class="constructor-variant__item">
                                <picture class="constructor-variant__picture constructor-variant__picture--max-width-70">
                                    <source type="image/webp" srcset="/img/constructor/VII/3.webp">
                                    <source type="image/png" srcset="/img/constructor/VII/3.png">
                                    <img src="/img/constructor/VII/3.png">
                                </picture>
                                
                                <button type="button" class="constructor-variant__btn constructor-variant__text" :class="{'constructor-variant__text--selected': steps[8] === 6}" @click="selectVariant(8, 6)">3</button>
                                <button type="button" class="constructor-variant__btn constructor-variant__text" :class="{'constructor-variant__text--selected': steps[8] === 7}" @click="selectVariant(8, 7)">5</button>
                                <button type="button" class="constructor-variant__btn constructor-variant__text" :class="{'constructor-variant__text--selected': steps[8] === 8}" @click="selectVariant(8, 8)">7</button>
                                <button type="button" class="constructor-variant__btn constructor-variant__text" :class="{'constructor-variant__text--selected': steps[8] === 9}" @click="selectVariant(8, 9)">9</button>- нечетное (и на внутр. и на наружн.)
                            </div>
                        </div>
                    </div>
                </transition>
                <transition name="tab">
                    <div class="conctructor-tabs__tab" v-show="tab === 9">
                        <br>
                    </div>
                </transition>
            </div>
            <div class="constructor-buttons">
                <button type="button" class="btn constructor__btn" @click="prevTab" v-if="tab > 0">Назад</button>
                <button type="button" class="btn constructor__btn constructor__btn--align-right" @click="sendChainToCard" v-if="tab === 9">Заказать</button>
                <button type="button" class="btn constructor__btn constructor__btn--align-right" @click="nextTab" v-if="tab < 8 && (tab !== 4 && steps[tab] != undefined || tab === 4 && steps[tab] === 0)">Вперед</button>
            </div>
        </div>
        <modals-container></modals-container>
    </div>
</template>

<script>
export default {
    name: 'chain-constructor',
}
</script>

<script setup>
import { ref, inject } from 'vue';
import ModalChainConstructor from '@js/components/ui/modals/modal-chain-constructor';
const progressLabels = ['I', 'II', 'ШАГ', 'III', '', 'IV', 'V', 'VI', 'VII'];
const variants = [
    [
        {text: 'M28', description: 's = 3,0'},
        {text: 'M40', description: 's = 3,5'},
        {text: 'M56', description: 's = 4,0'},
        {text: 'M80', description: 's = 5,0'},
        {text: 'M112', description: 's = 6,0'},
        {text: 'M160', description: 's = 7,0'},
        {text: 'M224', description: 's = 8,0'},
        {text: 'M315', description: 's = 10,0'},
        {text: 'M450', description: 's = 12,0'},
        {text: 'M630', description: 's = 14,0'},
        {text: 'M900', description: 's = 16,0'},
        {text: 'M1250', description: 's = 20,0'},
        {text: 'M1800', description: 's = 22,0'},
        {text: 'MC28', description: 's = 3,0'},
        {text: 'MC56', description: 's = 4,0'},
        {text: 'MC112', description: 's = 6,0'},
        {text: 'MC224', description: 's = 8,0'},
    ],
    [
        {image: 1, text: '1', description: '1 - Втулочная'},
        {image: 2, text: '2', description: '2 - Роликовая'},
        {image: 3, text: '3', description: '3 - Катковая'},
        {image: 4, text: '4', description: '4 - Каток с ребордой'},
    ],
    [40, 50, 63, 80, 100, 125, 160, 200, 250, 315, 400, 500, 630, 800, 1000],
    [
        {text: '1', description: '1 - неразборная (шплит 1 звено)', image: '1'},
        {text: '2', description: '2 - разборная (все звенья шплинтовые)', image: '2s'},
        {text: '2', description: '2 - разборная (все звенья ригельные)', image: '2r'},
        {text: '3', description: '3 - неразборная с полыми валиками', image: '3'},
    ],
    [
        {text: 'Да'},
        {text: 'Нет'},
    ],
    [
        {text: '1,1', description: '1,1 - специальные пластины с одним отверстием в полке', image: '1.1'},
        {text: '1,2', description: '1,2 - специальные пластины с двумя отверстиями в полке', image: '1.2'},
        {text: '2,1', description: '2,1 - специальные пластины без полки с одним отверстием', image: '2.1'},
        {text: '2,2', description: '2,2 - специальные пластины без полки с двумя отверстиями', image: '2.2'},
        {text: '5', description: '5 - Допускается изготавливать специальные пластины с отверстиями некруглой формы', image: '5'},
    ],
    [
        {text: '0', description: '0 - отсутствует (когда одно отверстие)'},
        {text: '1', description: '1 - наименьшее (от 0 до 100)'},
        {text: '2', description: '2 - среднее (от 100 до 200)'},
        {text: '3', description: '3 - наибольшее (от 200 и более)'},
    ],
    [
        {text: '1', description: '1 - одностороннее расположение спец. пластин в звене', image: '1'},
        {text: '2', description: '2 - двустороннее расположение спец. пластин в звене', image: '2'},
    ],
    [1, 2, 4, 6, 8, 10, 3, 5, 7, 9]
];

const steps = ref(new Array(9));
const tab = ref(0);
const modal = ref(null);
const modalsApi = inject('modalsApi');
const isSuccess = ref(false);

const selectTab = (index) => {
    tab.value = index;
}

const nextTab = () => {
    if (tab.value + 1 > variants.length) return;
    tab.value++;
}

const prevTab = () => {
    if (tab.value - 1 < 0) return;
    if (tab.value === 9 && steps.value[4] === 1) {
        tab.value = 4; return;
    }
    tab.value--;
}

const selectVariant = (baseIndex, variantIndex) => {
    steps.value[baseIndex] = variantIndex;
    isSuccess.value = false;

    if (baseIndex === 4 && variantIndex === 1) {
        tab.value = 9;
        for (let i = 5; i < steps.value.length; i++) {
            steps.value[i] = undefined;
        }
        return;
    }
    nextTab();
}

const isFilledTab = (index) => {
    if (index === 0) return true;

    if ((variants[index-1][steps.value[index-1]]?.text || variants[index-1][steps.value[index-1]]) !== undefined) return true

    return false;
}

const sendChainToCard = () => {

    if (modalsApi.get(modal.value).length) return;

    modal.value = modalsApi.show({
        component: ModalChainConstructor,
        bind: {
            steps: steps.value,
        },
        on: {
            "close": () => {
                modalsApi.close(modal.value);
            },
            "success": (data) => {
                for (let i = 0; i < steps.value.length; i++) {
                    steps.value[i] = undefined;
                }
                tab.value = 0;
                isSuccess.value = true;
                emitter.emit('cart-update', data.count)
                modalsApi.close(modal.value);
            }
        }
    })
}
</script>